"use strict";
exports.__esModule = true;
var TelegramChartDataSelector = /** @class */ (function () {
    function TelegramChartDataSelector(chart, containerElement) {
        this.chart = chart;
        this.containerElement = containerElement;
        this.buttons = [];
        this.chart.dataSelectorControl = this;
    }
    TelegramChartDataSelector.prototype.initializeButtons = function () {
        var data = this.chart.getDataSets(this.chart.currentZoomState);
        if (data != null) {
            this.containerElement.className = 'telegram-chart-data-selector';
            if (this.buttons.length != data.length) {
                for (var i = 0; i < this.buttons.length; i++) {
                    this.buttons[i].remove();
                    delete this.buttons[i];
                }
                this.buttons = this.buttons.filter(function (b) { return b; });
                for (var i = 0; i < data.length; i++) {
                    var button = this.chart.document.createElement('button');
                    button.innerHTML = TelegramChartDataSelector.checkIcon + ("<span>" + data[i].label + "</span>");
                    button.className = TelegramChartDataSelector.buttonClassName + " " + TelegramChartDataSelector.buttonCheckedClassName;
                    button.style.setProperty("--lineColor", data[i].color);
                    button.setAttribute(TelegramChartDataSelector.yIdAttributeName, data[i].id);
                    button.onclick = this.handleClick.bind(this, button, data[i].id);
                    this.containerElement.appendChild(button);
                    this.buttons.push(button);
                }
            }
        }
    };
    TelegramChartDataSelector.prototype.handleClick = function (button, yId) {
        var _this = this;
        var _loop_1 = function (i) {
            var t = this_1.chart.renderTargets[i];
            if (t.yVisibility[yId] == null) {
                t.yVisibility[yId] = true; // all lines are visible by default
            }
            if (t.yOpacity[yId] == null) {
                t.yOpacity[yId] = 1;
            }
            var show = !t.yVisibility[yId];
            var newOpacity = show ? 1 : 0;
            button.className = TelegramChartDataSelector.buttonClassName;
            if (show) {
                window.requestAnimationFrame(function () {
                    button.className += " checked";
                });
            }
            else {
                window.requestAnimationFrame(function () {
                    button.className += " unchecked";
                });
            }
            t.yVisibility[yId] = show;
            t.viewportChanged = true;
            // const renderTargetViewPortDataFrame = t.viewPortDataFrame.get(this.chart.currentZoomState);
            // const newYMinMax = this.chart.calculateYMinMax(
            //     this.chart.getCurrentZoomLevelData(),
            //     renderTargetViewPortDataFrame.x.min,
            //     renderTargetViewPortDataFrame.x.max,
            //     t.yVisibility,
            //     t.autoAdjustYMin ? null : 0
            // );
            // if (t.viewPortScalePerY) {
            //     const newZoomViewPortDataFramePerY = t.viewPortDataFramePerY.get(this.chart.currentZoomState);
            //     for (let ds of this.chart.getDataSets(this.chart.currentZoomState)) {
            //         if (t.yVisibility[ds.id] == null || t.yVisibility[ds.id] == true) {
            //             //newZoomViewPortDataFramePerY[ds.id].min = this.chart.roundYValue(newYMinMax[ds.id].min, true) - 1;
            //             //newZoomViewPortDataFramePerY[ds.id].max = this.chart.roundYValue(newYMinMax[ds.id].max) - 1;
            //             this.chart.animateYMaxMinChange(
            //                 this.chart.roundYValue(newYMinMax[ds.id].max, true),//newZoomViewPortDataFramePerY[ds.id].max + 1,
            //                 this.chart.roundYValue(newYMinMax[ds.id].min),//newZoomViewPortDataFramePerY[ds.id].min + 1,
            //                 t,
            //                 this.chart.currentZoomState,
            //                 ds.id
            //             );
            //         }
            //     }
            // } else {
            //     const newZoomViewPortDataFrame = t.viewPortDataFrame.get(this.chart.currentZoomState);
            //     //newZoomViewPortDataFrame.y.min = this.chart.roundYValue(newYMinMax[TelegramChart.yAllName].min, true) - 1;
            //     //newZoomViewPortDataFrame.y.max = this.chart.roundYValue(newYMinMax[TelegramChart.yAllName].max) - 1;
            //     this.chart.animateYMaxMinChange(
            //         this.chart.roundYValue(newYMinMax[TelegramChart.yAllName].max, true),//newZoomViewPortDataFrame.y.max + 1,
            //         this.chart.roundYValue(newYMinMax[TelegramChart.yAllName].min),  //newZoomViewPortDataFrame.y.min + 1,
            //         t, 
            //         this.chart.currentZoomState
            //     );
            // }
            var animationAlreadyInProgress = this_1.chart.animations
                .filter(function (a) { return a != null && a.animatedObject === _this.chart.renderTargets[i] && a.tag === "yIdOpacity" + yId; });
            if (animationAlreadyInProgress.length > 0 && animationAlreadyInProgress[0].endValue == newOpacity) {
                return { value: void 0 };
            }
            if (animationAlreadyInProgress.length < 1) {
                var anim = this_1.chart.getAnimation();
                anim.tag = "yIdOpacity" + yId;
                anim.animatedObject = t;
                anim.duration = this_1.chart.animationTimeMs;
                anim.easingFunction = this_1.chart.animationYScaleEasing;
                anim.startValue = t.yOpacity[yId];
                anim.endValue = newOpacity;
                anim.update = function (o, c, v) { o.yOpacity[yId] = v; o.viewportChanged = true; };
                this_1.chart.addAnimation(anim);
            }
            else {
                animationAlreadyInProgress[0].startTime = null;
                animationAlreadyInProgress[0].startValue = t.yOpacity[yId];
                animationAlreadyInProgress[0].endValue = newOpacity;
            }
        };
        var this_1 = this;
        for (var i = 0; i < this.chart.renderTargets.length; i++) {
            var state_1 = _loop_1(i);
            if (typeof state_1 === "object")
                return state_1.value;
        }
        this.chart.requestRender();
    };
    TelegramChartDataSelector.checkIcon = '<svg class="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52"><path class="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/></svg>';
    TelegramChartDataSelector.yIdAttributeName = 'telegram-chart-data-selector-y-id';
    TelegramChartDataSelector.buttonClassName = 'telegram-chart-data-selector-button';
    TelegramChartDataSelector.buttonCheckedClassName = 'checked';
    return TelegramChartDataSelector;
}());
exports.TelegramChartDataSelector = TelegramChartDataSelector;
//# sourceMappingURL=telegram-chart-data-selector.js.map